module.exports = __webpack_public_path__ + "media/images/start-60-ebc459e8a244a6f58bbb6c32241e5069.png";